import React, { FC } from 'react';
import classNames from 'classnames';
import Icon from 'components/ui/icon';
import showNotification from 'components/ui/notification/showNotification';
import { addTranslation, IntlProps } from 'decorators/addTranslation';
import './copyToClipboard.scss';

interface Props extends IntlProps {
  text: string | number;
  iconSize?: number;
  customClass?: any;
  children?: React.ReactNode;
}

const CopyToClipboard: FC<Props> = ({
  text,
  iconSize = 16,
  customClass = '',
  children,
  getTranslate,
}) => {
  
  const handleCopy = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    const textToCopy = String(text);

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          showNotification({
            status: 'success',
            content: getTranslate('common.copiedToClip.popup'),
          });
        })
    }
  };

  return (
    <div
      onClick={handleCopy}
      className={classNames('ui-copy-to-clipboard', {
        [customClass]: !!customClass,
      })}
      role="button"
    >
      {children || <Icon size={iconSize} name="im-Copy" />}
    </div>
  );
};

export default addTranslation(CopyToClipboard);
